import { FC } from "react";

import { useTranslation } from "next-i18next";

import { IconDropdown } from "@components/common";

import NoOptionsMessage from "./NoOptionsMessage";
import TimeOptionsGrid from "./TimeOptionsGrid";
import type { TTimeOption, TTimeSelectProps } from "./types";

const TimeSelect: FC<TTimeSelectProps> = ({
  id,
  isOpen,
  onToggleOpen,
  onClose,
  options,
  selectedTime,
  isDisabled,
  onSelect,
  noOptionsMessage,
}) => {
  const { t } = useTranslation();

  const handleOptionSelected = (option: TTimeOption) => {
    onSelect(option);
    onToggleOpen(false);
  };

  return (
    <IconDropdown
      id={id}
      isDisabled={isDisabled}
      isOpen={isOpen}
      onToggleOpen={onToggleOpen}
      onClose={() => {
        onToggleOpen(false);
        onClose?.();
      }}
      icon="clock"
      placement="bottom-end"
      offset={[0, 10]}
      title={t("common-time_picker-time_options")}
      isLazy
    >
      {options.length > 0 || !noOptionsMessage ? (
        <TimeOptionsGrid options={options} onSelect={handleOptionSelected} selectedTime={selectedTime} />
      ) : (
        <NoOptionsMessage message={noOptionsMessage} />
      )}
    </IconDropdown>
  );
};
export default TimeSelect;
